// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"188":"ae559b0b","695":"a0c345c0","896":"acdfc5e7","973":"b1de6082","986":"c099fbdc"}[chunkId] + ".chunk.js";
};